import { notification } from 'antd';
import { PureComponent, ReactNode } from 'react';
import Hotkeys from 'react-hot-keys';
import ModalDialog from '../common/ModalDialog';
import Modal from '../common/Modal';
import { apiRefreshResponse } from '../../api/fetchWithRefresh';
import { TProfileRecord } from '../../bridge/types';
import { checkIfValidPhoneNumber } from '../../pages/utils';

type Props = {
    oid?: string;
    mobile?: string;
    onClose: () => void;
    onComplete?: (profile?: TProfileRecord) => void;
    method: 'create_abha_with_mobile' | 'login_with_abha';
};

class CreateABHAModalSDK extends PureComponent<Props> {
    ABHA_CONTATINER_ID = 'abha-container';

    componentDidMount(): void {
        const { oid, mobile, onComplete, method } = this.props;
        apiRefreshResponse()
            .then((res) => {
                console.log('Refresh success:', res);
            })
            .catch((err) => {
                console.error('Refresh error:', err);
            });
        window.initAbhaApp?.({
            clientId: 'doc-web',
            containerId: this.ABHA_CONTATINER_ID,
            method,
            data: {
                mobile: checkIfValidPhoneNumber('+91', mobile?.replace('+91', ''))
                    ? mobile?.replace('+91', '')
                    : undefined,
                accessToken: '',
                oid: oid,
            },
            onSuccess: ({ response }) => {
                console.log('✅ ABHA Success:', response);
                onComplete?.(response.data?.profile);
                this.props.onClose();
            },
            onError: ({ error, response }) => {
                console.error('❌ ABHA Error:', error || response);
                notification.error({
                    message: 'Something went wrong!',
                    duration: 5,
                    description: error || response?.error?.message,
                });
                this.props.onClose();
            },
            onAbhaClose: () => {
                console.log('❌ ABHA Close');
                this.props.onClose();
            },
        });
    }

    render(): ReactNode {
        const { onClose } = this.props;
        return (
            <ModalDialog>
                <Hotkeys keyName="esc" onKeyDown={onClose}>
                    <Modal closeMe={onClose} contentCssClasses={'h-5/6 overflow-hidden'}>
                        <div id={this.ABHA_CONTATINER_ID} className="h-full overflow-auto"></div>
                    </Modal>
                </Hotkeys>
            </ModalDialog>
        );
    }
}

export default CreateABHAModalSDK;
